(ns hai.interfaces.chrome-sidebar.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]))

(defn interfaces-chrome-sidebar-page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Use Humble in your browser sidebar"]]
   [:div [:a {:href "https://chromewebstore.google.com/detail/humble-ai/bieekfeiaebohcjnfemcklfjkejndijd"
              :target "_blank"} "https://chromewebstore.google.com/detail/humble-ai/bieekfeiaebohcjnfemcklfjkejndijd"]]])